import { ROLES_LIMITED_BY_PRACTICING_STATES } from '~/shared/constants/careTeamRoles'
import { Provider } from './ProviderService'

const ADMIN = 'Admin'

export const isAdmin = (providers: Pick<Provider, 'id' | 'groups'>[], id: number | null) => {
  const foundProvider = providers.find(provider => provider.id === id)
  return !!foundProvider?.groups.find(group => group.name === ADMIN)
}

type ClinicalCareProvider = {
  groups: { name: string }[]
  provider_fields?: { practicing_states?: { abbreviation: string }[] | null } | null
}
type ClinicalCarePatient = {
  person?: { insurance_info?: { addresses?: { state?: string | null }[] | null } | null } | null
}

export const providerCanProvideClinicalCareToPatient = (
  provider: ClinicalCareProvider,
  patient: ClinicalCarePatient,
) => {
  // If provider does not have to have practicing states (ex, HG or OG)
  // then no restrictions should apply
  if (!hasLicensedRole(provider)) {
    return true
  }
  const providerStates = provider.provider_fields?.practicing_states
  const addresses = patient.person?.insurance_info?.addresses ?? []
  // Default to allowing care if we're missing info
  const [firstAddress] = addresses
  if (!firstAddress) {
    return true
  }
  const patientState = firstAddress.state
  if (providerStates && patientState) {
    return !!providerStates.find(state => state.abbreviation === patientState.toUpperCase())
  }
  return true
}

const hasLicensedRole = (provider: Pick<ClinicalCareProvider, 'groups'>): boolean =>
  !!(provider?.groups || []).find(g => ROLES_LIMITED_BY_PRACTICING_STATES.has(g.name))
